export default [{"url":"https://ikeja-0.api.invexerp.io","name":"Branch 1","port":"6513","isStore":true,"isHQ":true}]